export const textEvent = (string) => ({ target: { value: string } })

export const isTestEnvironment = () => {
  return window.location.host === "localhost:3000"
}
